import * as React from 'react';
import { Button, Grid, OutlinedInput, Typography, Box, FormControl, RadioGroup, FormControlLabel, Radio, FormHelperText, Select, MenuItem, Checkbox, Tooltip } from '@mui/material';
import constants from '../../../config/constants';
import { useSelector } from 'react-redux';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
export const initial_businessInfo = {
    role: '',
    location: '',
    locationID: ''
};
const BusinessInformation = (props) => {
    var _a;
    const { dealerLocations, handleSave, handleBack, prevProps } = props;
    const vendorConfig = useSelector((state) => state.vendor.vendorDetails);
    const [businessInfo, setBusinessInfo] = React.useState(Object.assign({}, initial_businessInfo));
    const [businessInfoErrors, setBusinessInfoErrors] = React.useState(Object.assign({}, initial_businessInfo));
    const [isAgreedToTerms, setIsAgreedToTerms] = React.useState(false);
    const [termsError, setTermsError] = React.useState(false);
    React.useEffect(() => {
        var _a, _b;
        if (prevProps && Object.values(prevProps).length > 0) {
            const __locationValue = (props === null || props === void 0 ? void 0 : props.dealerLocations) ? (_b = (_a = props === null || props === void 0 ? void 0 : props.dealerLocations) === null || _a === void 0 ? void 0 : _a.find((option) => option.label === (prevProps === null || prevProps === void 0 ? void 0 : prevProps.location))) === null || _b === void 0 ? void 0 : _b.label : businessInfo.location;
            const locationValue = __locationValue !== null && __locationValue !== void 0 ? __locationValue : '';
            const __businessInfo = Object.assign(Object.assign({}, prevProps), { location: locationValue });
            setBusinessInfo(__businessInfo);
        }
    }, [prevProps]);
    const roleValuesNew = [
        { RoleType: "hq-manager", RoleDescription: "HQ Manager", isDefaultChecked: false, label: 'HQ Manager', value: constants.roleTypes.HQMANAGER, toolTip: 'Role access request under review. Please click Register to continue.' },
        { RoleType: "branch-manager", RoleDescription: "Branch Manager", isDefaultChecked: false, label: 'Branch Manager', value: constants.roleTypes.BRMANAGER, toolTip: 'Role access request under review. Please click Register to continue.' },
        { RoleType: "VENDSREP", RoleDescription: (vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.PortalType) == 'BANKER' ? "Banker" : "Dealer/Vendor Sales Rep", isDefaultChecked: true, label: (vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.PortalType) == 'BANKER' ? "Banker" : 'Sales Representative', value: constants.roleTypes.VENDSREP, toolTip: '' },
    ];
    const isSalesRep = roleValuesNew.some(role => role.RoleType === constants.roleTypes.VENDSREP);
    React.useEffect(() => {
        const name = 'role';
        const value = constants.roleTypes.VENDSREP;
        setBusinessInfoErrors((prevData) => (Object.assign(Object.assign({}, businessInfoErrors), { [name]: '' })));
        setBusinessInfo((prevData) => (Object.assign(Object.assign({}, prevData), { [name]: value })));
    }, [isSalesRep]);
    const handleOnValChange = (e) => {
        let { name, value } = e.target;
        setBusinessInfoErrors((prevData) => (Object.assign(Object.assign({}, businessInfoErrors), { [name]: '' })));
        setBusinessInfo((prevData) => (Object.assign(Object.assign({}, prevData), { [name]: value })));
    };
    const trimAndValidate = (value) => {
        const trimmedValue = value.trim();
        if (trimmedValue === '') {
            return 'This field is required';
        }
        else {
            return '';
        }
    };
    const handlePreviousStep = () => {
        handleBack(0, businessInfo);
    };
    const handleSubmit = () => {
        var _a, _b, _c;
        const isFormValid = isValidFormData();
        const hasAcceptedTerms = isAgreedToTerms;
        setTermsError(!hasAcceptedTerms);
        if (isFormValid && hasAcceptedTerms) {
            let locationLabel = '', locationId = '';
            if (props === null || props === void 0 ? void 0 : props.dealerLocations) {
                let selectedLocation = (_a = props === null || props === void 0 ? void 0 : props.dealerLocations) === null || _a === void 0 ? void 0 : _a.find((option) => option.label === businessInfo.location);
                locationLabel = (_b = selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.label) !== null && _b !== void 0 ? _b : '';
                locationId = (_c = selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.value) !== null && _c !== void 0 ? _c : '';
            }
            const __businessInfo = Object.assign(Object.assign({}, businessInfo), { location: locationLabel, locationID: locationId });
            handleSave(__businessInfo);
        }
    };
    const handleOnInputBlur = (e) => {
        const { name, value } = e.target;
        isValidFormData(name, value);
    };
    const isValidFormData = (fieldName = 'All', value) => {
        let _busiinessInfo = Object.assign(Object.assign({}, businessInfo), { [fieldName]: value });
        let errorInfo = Object.assign({}, businessInfoErrors);
        switch (fieldName) {
            case 'All':
            case 'role':
                errorInfo.role = trimAndValidate(_busiinessInfo.role);
                if (fieldName !== 'All')
                    break;
            case 'All':
            case 'location':
                errorInfo.location = trimAndValidate(_busiinessInfo.location);
        }
        setBusinessInfoErrors(() => (Object.assign({}, errorInfo)));
        return Object.values(errorInfo).every(errorMsg => errorMsg === '');
    };
    return (React.createElement(Box, { className: 'signup-step-two' },
        React.createElement(Grid, { container: true, spacing: 1 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormControl, { fullWidth: true, error: Boolean(businessInfoErrors.role) },
                    React.createElement(Typography, { className: 'signup-field-label' }, "Select your role"),
                    React.createElement(RadioGroup, { name: 'role', value: (_a = businessInfo.role) !== null && _a !== void 0 ? _a : '', onChange: handleOnValChange, onBlur: handleOnInputBlur, className: 'signup-role-group' }, roleValuesNew.map((roleItem) => (React.createElement(Box, { key: roleItem.value, className: `signup-role-card ${businessInfo.role === roleItem.value ? 'selected' : ''}` },
                        React.createElement(FormControlLabel, { className: 'signup-role-option', value: roleItem.value, control: React.createElement(Radio, { size: 'small' }), label: roleItem.label, checked: roleItem.isDefaultChecked && !businessInfo.role ? roleItem.isDefaultChecked : undefined }),
                        roleItem.value !== constants.roleTypes.VENDSREP && (React.createElement(Tooltip, { title: roleItem.toolTip || '', arrow: true, placement: 'top' },
                            React.createElement(InfoOutlinedIcon, { className: 'info-icon' }))))))),
                    React.createElement(FormHelperText, null, businessInfoErrors.role))),
            React.createElement(Grid, { item: true, xs: 12, pb: '8px' },
                React.createElement(FormControl, { fullWidth: true, className: 'signup-location-select', error: Boolean(businessInfoErrors.location) },
                    React.createElement(Select, { value: businessInfo.location, displayEmpty: true, onChange: handleOnValChange, onBlur: handleOnInputBlur, input: React.createElement(OutlinedInput, null), name: 'location', size: 'small', IconComponent: ExpandMoreIcon, renderValue: (selected) => {
                            if (!selected) {
                                return (React.createElement(Box, { className: 'signup-location-placeholder' },
                                    React.createElement(Typography, { component: 'span' }, "Location"),
                                    React.createElement(Typography, { component: 'span', className: 'required-indicator' }, "*")));
                            }
                            return selected;
                        } }, ((dealerLocations === null || dealerLocations === void 0 ? void 0 : dealerLocations.length) || 0) > 0
                        ? dealerLocations === null || dealerLocations === void 0 ? void 0 : dealerLocations.map((option, i) => (React.createElement(MenuItem, { key: i, value: option.label }, option.label)))
                        : null),
                    React.createElement(FormHelperText, null, businessInfoErrors.location))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Box, { sx: { display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: 1, mt: 1 } },
                    React.createElement(Checkbox, { checked: isAgreedToTerms, onChange: (event) => {
                            const isChecked = event.target.checked;
                            setIsAgreedToTerms(isChecked);
                            if (termsError) {
                                setTermsError(!isChecked);
                            }
                        }, icon: React.createElement(CheckBoxOutlineBlankIcon, null), checkedIcon: React.createElement(CheckBoxOutlinedIcon, null), sx: {
                            p: 0,
                            flexShrink: 0,
                            alignSelf: 'flex-start',
                            mt: '2px',
                            color: termsError ? '#F00214' : '#20285c',
                            '&.Mui-checked': {
                                color: termsError ? '#F00214' : '#20285c',
                            },
                        } }),
                    React.createElement(Box, { sx: { flex: 1, fontSize: '14px', lineHeight: 1.5, color: '#14151C' } },
                        "I have read and agreed to the",
                        React.createElement(Typography, { component: 'a', href: 'https://auxcap.com/terms-of-use/', target: '_blank', rel: 'noopener noreferrer', className: 'link-text' }, "Terms and Conditions"),
                        "and the",
                        React.createElement(Typography, { component: 'a', href: 'https://auxcap.com/privacy-policy/', target: '_blank', rel: 'noopener noreferrer', className: 'link-text' }, "Privacy Policy"))),
                termsError && (React.createElement(FormHelperText, { error: true, sx: { marginLeft: '32px' } }, "Please accept Terms and Conditions and Privacy Policy."))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Grid, { container: true, spacing: 1, mt: 3 },
                    React.createElement(Grid, { item: true, xs: 6 },
                        React.createElement(Button, { fullWidth: true, variant: 'outlined', className: 'btn-txt btn-primary', onClick: handlePreviousStep }, "Back")),
                    React.createElement(Grid, { item: true, xs: 6 },
                        React.createElement(Button, { fullWidth: true, variant: 'contained', className: 'btn-txt btn-primary', onClick: handleSubmit }, "Register")))))));
};
export default BusinessInformation;
